import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import { RoundMode } from '../../../../../services/interfaces';
import type { MatchHeaderStoreState } from '../../../../../services/interfaces/match-header';
import { calendarDateFormat } from '../../../../../services/libraries';
import { translateEntity } from '../../../../../services/utils';

type Props = {
  state: ObservableMap<MatchHeaderStoreState>['state'];
};

const MatchContext = ({ state }: Props) => {
  const match = state.matchData;
  if (!match) return null;

  const isCompactMode = state.isCompactMode;
  const dateCalendarFormat = state.dateCalendarFormat;
  const customTimeZone = state.customTimeZone;

  const matchDate = match.kickOffTime?.dateTime ?? match.kickOffTime?.date;
  const kickOffDateLocale = matchDate ? calendarDateFormat(matchDate, dateCalendarFormat, customTimeZone) : '';
  const showDateElement = !!matchDate;

  const language = state.language;
  const roundName = translateEntity(match.round, language)?.name;
  const legName = translateEntity(match.leg, language)?.name;
  const matchdayName = translateEntity(match.matchday, language)?.longName;

  return (
    <div class={{ 'pk-match-header__context': true, hidden: isCompactMode }} part="match-context">
      {showDateElement && (
        <span class="pk-match-header__context--date" part="match-date">
          {kickOffDateLocale}
        </span>
      )}

      <span class="pk-match-header__context--round" part="round-name">
        {roundName}
      </span>
      {([RoundMode.KNOCK_OUT, RoundMode.FINAL] as RoundMode[]).includes(match.round?.mode) && legName && (
        <span class="pk-match-header__context--legname" part="leg-name">
          {legName}
        </span>
      )}
      {match.round?.mode === RoundMode.GROUP && matchdayName && (
        <span class="pk-match-header__context--matchday" part="matchday-name">
          {matchdayName}
        </span>
      )}
      <pk-divider class="w-full"></pk-divider>
    </div>
  );
};

export { MatchContext };
